import { Menu, Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { ThemeToggle } from '@/lib/theme/theme-toggle';
import { cn } from '@/lib/utils';
import { NotificationsPopover } from './notifications-popover';
import { SearchModal } from './search-modal';
import { TenantSwitcher } from './tenant-switcher';
import { UserMenu } from './user-menu';

interface Props {
  userName: string | null | undefined;
  userEmail: string | null | undefined;
  onOpenMobileMenu: () => void;
}

export function Topbar({ userName, userEmail, onOpenMobileMenu }: Props) {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {/*
        Mesma declaracao de bg/blur da sidebar (ver sidebar.tsx) — cor
        identica "por construcao" nos 3 temas, em vez de duas aproximacoes
        via color-mix que so pareciam iguais por coincidencia. Precisa de
        bg proprio (nao da pra so herdar da raiz do DashboardShell): o
        header e sticky, entao o conteudo rolado passa POR TRAS dele — sem
        pintura propria, esse conteudo vazaria por cima do header vazio.
        Sem border-b: o contraste de cor + o canto arredondado da "dobra"
        (ver dashboard-shell.tsx) marcam a fronteira com o conteudo, uma
        linha reta ali competia com o corte arredondado.
      */}
      <header className="sticky top-0 z-30 flex h-16 items-center gap-3 bg-[var(--surface)] px-4 backdrop-blur-[var(--blur)] md:px-6">
        <button
          type="button"
          onClick={onOpenMobileMenu}
          aria-label="Abrir menu"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md text-[var(--fg)] hover:bg-[color-mix(in_oklch,var(--fg)_8%,transparent)] md:hidden"
        >
          <Menu className="h-4 w-4" />
        </button>

        <button
          type="button"
          data-tour="topbar-search"
          onClick={() => setSearchOpen(true)}
          aria-label="Buscar"
          className={cn(
            'flex flex-1 items-center gap-2 rounded-md border px-3 py-2 text-sm transition',
            'border-[var(--border)] bg-[var(--surface-muted)] text-[var(--fg-muted)] hover:bg-[color-mix(in_oklch,var(--fg)_4%,transparent)]',
            'max-w-md md:ml-4',
          )}
        >
          <Search className="h-4 w-4 shrink-0" />
          <span className="flex-1 truncate text-left">Buscar...</span>
          <kbd className="rounded border border-[var(--border)] px-1.5 py-0.5 text-xs">
            ⌘K
          </kbd>
        </button>

        <div className="ml-auto flex items-center gap-1">
          <div className="hidden md:block">
            <TenantSwitcher />
          </div>
          <NotificationsPopover />
          <ThemeToggle />
          <UserMenu name={userName} email={userEmail} />
        </div>
      </header>

      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}
